"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionMediaMetadataDtoFileTypeEnum = void 0;
exports.SubmissionMediaMetadataDtoFileTypeEnum = {
    Png: 'png',
    Jpg: 'jpg',
    Jpeg: 'jpeg',
    Mp4: 'mp4',
    Mov: 'mov',
    Wav: 'wav',
    Gif: 'gif',
    Webp: 'webp'
};
